@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
    height: 100vh;
    overflow: hidden;
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.inner {
    position: relative;
    height: 100%;
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.card {
    position: absolute;
    width: calc(100% - calc(var(--labui-container-margin) * 2));
    height: 100vh;
    top: 0;
    left: var(--labui-container-margin);
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    padding-block: var(--spacer-56);
    background-color: var(--color-primary);

    @media ($above-mobile) {
        height: 100vh;
    }
}

.cardMedia {
    flex: 1;
    position: relative;
    overflow: hidden;

    @media ($below-mobile) {
        width: 100%;
        aspect-ratio: 2;
    }

    & :is(img, video) {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
}

.cardContent {
    flex-shrink: 0;
}

.cardTitle {
    margin-top: var(--spacer-32);
    font: var(--font-h-40);
    text-align: center;
}

.cardColumns {
    composes: grid from "../../styles/composable/layout.module.css";
}

.cardColumnsInner {
    grid-column: 2 / span 10;
    display: flex;
    gap: var(--spacer-24);
    margin-top: var(--spacer-24);
    padding-top: var(--spacer-16);
    border-top: 1px solid var(--color-contrast);

    @media ($below-mobile) {
        grid-column: 1 / -1;
        flex-direction: column;
    }
}

.cardColumn {
    flex: 1 0 0%;
    font: var(--font-p-18);
}

.cardColumnSingle {
    text-align: center;
}

.cardColumnTitle {
    font-weight: 700;
}
